import { useEffect, useState } from 'react';
import { fetchTrialState } from 'purchase-motions-api/query/trials';
export const useTrialState = () => {
  var _data$activeTrials, _data$expiredTrials;
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [data, setData] = useState();
  useEffect(() => {
    fetchTrialState().then(response => {
      setData(response);
      setLoading(false);
    }).catch(e => {
      setError(e);
      setLoading(false);
    });
  }, []);
  const activeTrials = (_data$activeTrials = data === null || data === void 0 ? void 0 : data.activeTrials) !== null && _data$activeTrials !== void 0 ? _data$activeTrials : new Set();
  const expiredTrials = (_data$expiredTrials = data === null || data === void 0 ? void 0 : data.expiredTrials) !== null && _data$expiredTrials !== void 0 ? _data$expiredTrials : new Set();
  return {
    loading,
    error,
    trialState: {
      activeTrials,
      expiredTrials
    }
  };
};